import React from 'react';
import { Divider, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Mail as MailIcon, AccountCircle as AccountIcon, ExitToApp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import VerifiedBadgeNotification from '../Auth/VerifiedBadgeNotification';
import CustomIcon from '../DesignSystem/CustomIcon';
import { Icons } from '../../Themes';
import AnalyticsService from '../../Services/AnalyticsService';
import useSpace from '../../Hooks/useSpace';
import { loginPath, spacePath } from '../../Utils/routes';
import useCurrentUser from '../../Hooks/useCurrentUser';

const StyledNavLink = React.forwardRef(({ className, ...props }: any, ref: any) => (
  <NavLink
    ref={ref}
    className={({ isActive }: any) => (isActive ? `${className} Mui-selected` : className)}
    {...props}
  />
));

StyledNavLink.displayName = 'StyledNavLink';

function ProfileMenuItems({ onClick, nested = false, verified }: any) {
  const { space } = useSpace();
  const { logout } = useCurrentUser();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    AnalyticsService.track('Authentication', 'Logout');

    try {
      await logout();
      navigate(space.public ? spacePath() : loginPath());
      onClick();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <>
      <ListItemButton
        onClick={onClick}
        role="list"
        to={`/${space.slug}/account/settings`}
        component={StyledNavLink}
        sx={{ ...(nested && { pl: 4 }) }}
      >
        <ListItemIcon>
          <VerifiedBadgeNotification verified={verified} noIcon={true}>
            <AccountIcon />
          </VerifiedBadgeNotification>
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="NAVBAR.MY_ACCOUNT" />
        </ListItemText>
      </ListItemButton>

      <ListItemButton
        onClick={onClick}
        role="list"
        to={`/${space.slug}/contributions/participation`}
        component={StyledNavLink}
        sx={{ ...(nested && { pl: 4 }) }}
      >
        <ListItemIcon>
          <CustomIcon src={Icons.misc.bulb} />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="SPACE.CONTRIBUTIONS.PROPOSALS.TITLE" />
        </ListItemText>
      </ListItemButton>

      <ListItemButton
        onClick={onClick}
        role="list"
        to={`/${space.slug}/contributions/messaging`}
        component={StyledNavLink}
        sx={{ ...(nested && { pl: 4 }) }}
      >
        <ListItemIcon>
          <MailIcon />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="SPACE.CONTRIBUTIONS.MESSAGING.TITLE" />
        </ListItemText>
      </ListItemButton>
      <Divider />
      <ListItemButton onClick={handleSignOut} role="list" sx={{ ...(nested && { pl: 4 }) }}>
        <ListItemIcon>
          <ExitToApp />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="SIGN_OUT" />
        </ListItemText>
      </ListItemButton>
    </>
  );
}

export default ProfileMenuItems;
